// Client copy of the backend's championship name rule (backend
// helpers/championship.js isChampByName; keep in step, and in step with the
// web app's src/helper/championship.js). Only used to pre-tick a
// Championship box for a new or renamed competition; the saved flag counts.
const CHAMP_GROUP = /^\s*(PRELIMINARY|OPEN)\s+CHAMPIONSHIPS?\s*$/i;
const CHAMP_WORD = /\bCHAMP(IONSHIP)?S?\b|\bPRELIM(INARY)?\b|\bADVANCED\s+ADULT\b|\bADULT\s+ADVANCED\b/i;
const FUTURE_CHAMP = /\bFUTURE\b/i;
// team and pair dances in any group: TEAMS group, "n-HAND", pairs/duets/trios,
// ceili, figure and dance-drama, parent & child
const TEAM_OR_PAIR =
  /^\s*TEAMS?\s*$|\b\d+\s*-?\s*HAND\b|\bTWO[\s-]HAND\b|\bPARENT\b|\bTEAMS?\b|\bPAIRS?\b|\bDUETS?\b|\bDUOS?\b|\bTRIOS?\b|\bCEILI\b|\bFIGURE\b|\bDANCE\s+DRAMA\b|\bCHOREOGRAPH/i;
const CHAMP_LEVELS = new Set(['PRELIMINARY CHAMPIONSHIPS', 'OPEN CHAMPIONSHIPS']);
const GRADE_LEVELS = new Set(['FIRST FEIS', 'BEGINNER', 'BEGINNER 1', 'BEGINNER 2', 'ADVANCED BEGINNER', 'NOVICE', 'PRIZEWINNER']);
export function suggestChampionship({ group = '', description = '', levels = [] }) {
  const text = `${group} ${description}`;
  if (FUTURE_CHAMP.test(text)) return false;
  if (TEAM_OR_PAIR.test(group) || TEAM_OR_PAIR.test(text)) return false;
  if (CHAMP_GROUP.test(group)) return true;
  // eligibility: only Prelim/Open ticked = championship; any grade level = not
  const lv = (levels || []).map((l) => String(l).trim().toUpperCase());
  if (lv.length && lv.every((l) => CHAMP_LEVELS.has(l))) return true;
  if (lv.some((l) => GRADE_LEVELS.has(l))) return false;
  return CHAMP_WORD.test(text);
}
